import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// PostHog is no longer initialised on import — the cookie-consent gate
// (components/CookieConsent.jsx) calls initPostHog() only after consent.
import './theme.js'; // FIRST — stamps data-theme on <html> before first paint
import './pwa.js'; // install-prompt capture + service-worker registration (prod)
import { AuthProvider } from './auth/AuthContext.jsx';
import App from './App.jsx';
import './styles.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);

// The BRAGS-13 reminder scheduler has no first-paint role and no early event
// listeners, so it's deferred off the critical path into its own chunk and
// started when the browser is idle — it still runs well before any user action
// that needs it. (theme.js and pwa.js stay eager: theme prevents a flash, and
// pwa.js must register its `load`/`beforeinstallprompt` listeners early.)
function startReminders() {
  import('./reminders.js').catch((err) => {
    console.warn('[boot] reminder engine failed to load:', err);
  });
}
if ('requestIdleCallback' in window) {
  requestIdleCallback(startReminders, { timeout: 3000 });
} else {
  setTimeout(startReminders, 2000);
}
